export default {
  convertToTwoCharacterType(num) {
    return num > 9 ? num : '0' + num;
  },
};
